import {formatDate, buildColumn, XLARGE_CELL_WIDTH} from '@eitje/web_components'
import {AdminsCell, TranslationCell, FirmStatusCell} from '~/components/advanced_table/components/cells'

export const columns = [
	{
		accessorKey: 'naam',
		width: XLARGE_CELL_WIDTH,
	},
	{
		accessorKey: 'status',
		cell: FirmStatusCell,
		groupedTotalInChild: true,
		infoIconMessageProps: {
			title: 'status',
			body: 'tooltips.status',
		},
	},
	{
		id: 'organisation_name',
		accessorFn: environment => environment.organisation?.name,
	},
	{
		id: 'admins',
		accessorFn: environment => environment.admins._map('id').sort().join(','), // create normalized string to make grouping work
		cell: AdminsCell,
		aggregates: false,
		groupedTotalInChild: true,
	},
	{
		id: 'created_at',
		accessorFn: environment => _.first(environment.created_at.split('T')), // create normalized string to make grouping work
		format: formatDate,
	},
	{
		accessorKey: 'activeUsers',
		header: 'active_users',
		collapsibleCell: 'sumValues',
		aggregatesFn: 'sumValues',
	},
	{
		accessorKey: 'city',
	},
	{
		id: 'tier',
		accessorFn: environment => environment.tier && `records.default.fields.subscription_tier.${environment.tier}`,
		cell: TranslationCell,
		aggregates: false,
	},
	{
		accessorKey: 'id',
	},
].map(buildColumn)
